// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hq3bn","col":"styles_col__3vJFK"};